import { gql } from '@grandvisionhq/graphql';

/**
 * When a user returns from the social login provider we need to activate the account in Auth0.
 * This mutation does two things:
 * - send to the BE that this account can be activated
 * - return possible mergeable accounts
 */ const ACTIVATE_SOCIAL_ACCOUNT = gql`
  mutation activateSocialAccount {
    activateSocialAccount {
      mergeableAccounts {
        email
        id
      }
    }
  }
`;

export { ACTIVATE_SOCIAL_ACCOUNT };
//# sourceMappingURL=activate-social-account.js.map
